import locale from "@bonliva-crm/locale";
import {
  CallIcon,
  ChatBubbleIcon,
  Color,
  FavoriteIcon,
  ListsIcon,
  MailIcon,
  NewsIcon,
  PhoneDisabledIcon
} from "@bonliva-crm/ui";
import { IconButton, Tooltip, Typography, makeStyles } from "@material-ui/core";
import { transparentize } from "polished";
import { MainFilterType } from "../utils/filter-type";

type Props = {
  badgeType: MainFilterType | null;
  selected: boolean;
  setSelected: (selected: boolean) => void;
};

export const FilterBadge = ({ badgeType, selected, setSelected }: Props) => {
  const classes = useStyles({ selected });

  const icon = (() => {
    switch (badgeType) {
      case null:
        return <ListsIcon className={classes.icon} />;
      case MainFilterType.Call:
        return <CallIcon className={classes.icon} />;
      case MainFilterType.Noanswer:
        return <PhoneDisabledIcon className={classes.icon} />;
      case MainFilterType.Email:
        return <MailIcon className={classes.icon} />;
      case MainFilterType.SMS:
        return <ChatBubbleIcon className={classes.icon} />;
      case MainFilterType.Comment:
        return <NewsIcon className={classes.icon} />;
      case MainFilterType.Interest:
        return <FavoriteIcon className={classes.icon} />;
      default:
        return undefined;
    }
  })();

  const toolTipTitle = (() => {
    if (badgeType === null) return locale.Everything;
    return locale.consultantEventTypesNew[badgeType];
  })();

  return (
    <Tooltip title={toolTipTitle} placement="bottom-start">
      <IconButton className={classes.iconButton} onClick={() => setSelected(!selected)}>
        {icon}
        {badgeType === null && (
          <Typography variant="body1" className={classes.text}>
            {locale.Everything}
          </Typography>
        )}
      </IconButton>
    </Tooltip>
  );
};

type StyleProps = {
  selected: boolean;
};

const useStyles = (props: StyleProps) =>
  makeStyles((theme) => ({
    text: {
      margin: "0 auto",
      color: props.selected ? Color.White : Color.Gray
    },
    icon: {
      fill: props.selected ? Color.White : Color.Gray
    },
    iconButton: {
      backgroundColor: props.selected ? Color.PrimaryMain : "transparent",
      borderRadius: "0.25rem",
      padding: "0.25rem",
      minWidth: "2rem",
      height: "2rem",
      "&:hover": {
        backgroundColor: props.selected
          ? transparentize(0.5, Color.PrimaryMain)
          : undefined
      }
    }
  }))();
